import { PrimaryColors } from '@picsart/design-system/foundation/primaryColors';
import { BrandColors } from '@picsart/design-system/foundation/brandColors';
import { TextColors } from '@picsart/design-system/foundation/textColors';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { ErrorColors } from '@picsart/design-system/foundation/errorColors';
import { WarningColors } from '@picsart/design-system/foundation/warningColors';
import { InformationColors } from '@picsart/design-system/foundation/informationColors';
import { AbsolutesWhiteColors } from '@picsart/design-system/foundation/absolutesWhiteColors';
import { NegativeColors } from '@picsart/design-system/foundation/negativeColors';
import { generateTheme, ThemeDarkValues, ThemeLightValues } from '@picsart/design-system/foundation/themes';

const colors = {
  accents: {
    primary: PrimaryColors,
    secondary: BrandColors,
  },
  texts: {
    ...TextColors,
    negative: NegativeColors.text.default,
  },
  backgrounds: BackgroundColors,
  statuses: {
    error: ErrorColors,
    warning: WarningColors,
    information: InformationColors,
  },
  absolutes: {
    white: AbsolutesWhiteColors,
  },
};

const getColor = (key: string): string => getComputedStyle(document.documentElement).getPropertyValue(key);

const changeThemeColors = ({ isDark }: { isDark: boolean }) => {
  const styleTag = document.createElement('style');
  styleTag.innerText = `
    :root {
      ${Object.entries(generateTheme(isDark ? ThemeDarkValues : ThemeLightValues)).reduce((acc, [color, value]) => `${acc}${color}: ${value};\n`, '')}
    }
  `;
  return styleTag;
};

export { colors, getColor, changeThemeColors };
